(() => {
  /** JSDoc
   * @typedef {object} Variant
   * @property {string} id
   * @property {string} featured_media_id
   */

  /** JSDoc
   * @param {object} config
   * @param {[HTMLElement, function(string): string][]} config.elements
   * @param {Variant} config.variants
   * @param {string[]} config.mediaIds
   * */
  function registerOnlyVariantImages(config) {
    const updateImagesWithVariant = updateImages(
      config.elements,
      config.variants,
      config.mediaIds,
    );

    return window.updateImagesWithVariant = updateImagesWithVariant;
  }
  document.dispatchEvent(new CustomEvent('variant:register-images', {
    detail: {
      fn: registerOnlyVariantImages
    }
  }));

  /** JSDoc
    * @param {string} currentId
   * @param {Variant[]} variants
   * @returns {string}
   * */
  function getNextMediaId(currentId, variants, mediaIds) {
    const currentVariant = variants.find((variant) => variant.id === currentId);
    const currentIndex = variants.indexOf(currentVariant);
    const nextVariant = variants.find((variant, index) => {
      return index > currentIndex && variant.featured_media_id && mediaIds.findIndex((mediaId) => mediaId == variant.featured_media_id) > mediaIds.findIndex((mediaId) => mediaId == currentVariant.featured_media_id);
    })
    return nextVariant?.featured_media_id;
  }

  /** JSDoc
   * @param {Variant} currentVariant
   * @param {Variant[]} variants
   * @returns {string[]}
   * */
  function getCorrespondingMediaIds(currentVariant, variants, mediaIds) {
    const startId = currentVariant.featured_media_id;
    const endId = getNextMediaId(currentVariant.id, variants, mediaIds);
    return [startId, endId];
  }

  /** JSDoc
    * @param {[HTMLElement, function(string): HTMLElement][]} elements
    * @param {string[]} mediaIds
    * @param {string} mediaIdsToShow
    * */
  function hideMediaUnlessInList(element, mediaIds, mediaIdsToShow) {
    const [parent, matchingFunction] = element;
    for (const mediaId of mediaIds) {
      const media = matchingFunction(parent, mediaId);
      if (!media) continue;
      const shouldShow = mediaIdsToShow.includes(mediaId)
      media.classList.toggle("hidden", !shouldShow);
    }
  }

  /** JSDoc
   * @param {[HTMLElement, function][]} elements
   * @param {Variant[]} variants
   * @param {string[]} mediaIds
   * @returns {function(string): void}
   * */
  function updateImages(elements, variants, mediaIds) {
    return function (variantId) {
      const variant = variants.find((variant) => variant.id === variantId);
      const [startId, endId] = getCorrespondingMediaIds(variant, variants, mediaIds);
      const start = mediaIds.indexOf(startId);
      const end = endId ? mediaIds.indexOf(endId) : undefined;
      const mediasToShow = mediaIds.slice(start, end);

      for (const element of elements) {
        hideMediaUnlessInList(element, mediaIds, mediasToShow);
      }
    };
  }

  document.addEventListener("variant:change", (event) => {
    const variant = event.detail.variant.id;
    if (window.updateImagesWithVariant) {
      window.updateImagesWithVariant(variant);
    }
  });
})();
